import { FC } from "react";
import orderTranslationsHelper from "../../../../../../../languages/order-translations.helper";
import { OrderDetailsHistoryEntryDealerApprovalEvent } from "../../../common/types/order-details-history-entry-event";

type OrderDetailsHistoryEntryDealerApprovalContentProps = {
  event: OrderDetailsHistoryEntryDealerApprovalEvent;
};

const OrderDetailsHistoryEntryDealerApprovalContentComponent: FC<
  OrderDetailsHistoryEntryDealerApprovalContentProps
> = () => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations().dealerApprovalEntry;

  return (
    <div className="order_details_history_entry_list_item_content">
      <div className="order_details_history_entry_list_item_content__heading_text">
        {translations.headingText}
      </div>
    </div>
  );
};

export default OrderDetailsHistoryEntryDealerApprovalContentComponent;
